import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface TotalStopsIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export default function TotalDriversIcon({
  color = RoutalPalette.secondary60,
  style = {},
  ...props
}: TotalStopsIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 14" style={{ width: `13px`, height: `13px`, ...style }}>
      <g>
        <path
          d="M16.6408 2.17035C16.2628 1.45318 15.4898 1 14.6446 1H2.488C1.66588 1 1 1.63176 1 2.41176V10.1765C1 10.5661 1.33331 10.8823 1.744 10.8823H2.632C2.632 9.7127 3.63119 8.7647 4.864 8.7647C6.09681 8.7647 7.096 9.7127 7.096 10.8823H11.56C11.56 9.7127 12.5592 8.7647 13.792 8.7647C15.0248 8.7647 16.024 9.7127 16.024 10.8823H18.256C18.6667 10.8823 19 10.5661 19 10.1765V6.64706L16.6408 2.17035Z"
          fill={color}
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.86384 13C6.09654 13 7.09584 12.0519 7.09584 10.8824C7.09584 9.71281 6.09654 8.76471 4.86384 8.76471C3.63114 8.76471 2.63184 9.71281 2.63184 10.8824C2.63184 12.0519 3.63114 13 4.86384 13Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.7921 13C15.0248 13 16.0241 12.0519 16.0241 10.8824C16.0241 9.71281 15.0248 8.76471 13.7921 8.76471C12.5594 8.76471 11.5601 9.71281 11.5601 10.8824C11.5601 12.0519 12.5594 13 13.7921 13Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1.50391 2.5072C1.50391 1.95492 1.95162 1.5072 2.50391 1.5072H11.662V5.43823H1.50391V2.5072Z"
          fill={RoutalPalette.neutral00}
        />
        <path
          d="M12.6548 1.49887C12.6548 1.49887 13.0115 1.49887 14.3982 1.49887C15.7849 1.49887 16.0579 2.13137 16.4724 2.91794C17.1208 4.14843 17.4594 4.79093 17.7946 5.4382C16.4823 5.4382 12.6548 5.4382 12.6548 5.4382V1.49887Z"
          fill={RoutalPalette.neutral00}
        />
      </g>
    </SvgIcon>
  );
}
